import { useEffect } from 'react'

export const useChangePassword = setIsLoading => {
  useEffect(() => {
    setIsLoading(false)
  }, [])
}
